export class SendingEventError extends Error {
  constructor(message) {
    super(`Error sending event ${message}`)
    this.name = 'SendingEventError'
  }
}
